import "../../assets/style/DataAnalytics.css";

import Topbar from "../../component/Topbar/Topbar";
import Footer from "../../component/Footer/Footer";
import checklist from "../../assets/icon/checklist.svg";
import checklistSize from "../../assets/icon/checklistSize.svg";

import bg from "../../assets/photo/dataBackground.webp"
import { useTranslation } from "react-i18next";

function DataAnalytics(params) {
    const { t } = useTranslation();
    const listitem = [
        "Descriptive Analytics",
        "Diagnostic Analytics",
        "Predictive Analytics",
        "Prescriptive Analytics",
        "Real-Time Analytics",
        "Data Visualization",
        "Customer Analytics",
        "Operational Analytics"
    ]

    const listwhy = [{
        title: "Expertise",
        text: t("dataanalyticservice1"),
    },
    {
        title: "Customization",
        text: t("dataanalyticservice2"),
    },
    {
        title: "Advanced Tools",
        text: t("dataanalyticservice3"),
    },
    {
        title: "Scalability",
        text: t("dataanalyticservice4"),
    },
    {
        title: "Data Security",
        text: t("dataanalyticservice5"),
    },
    {
        title: "Continuous Support",
        text: t("dataanalyticservice6"),
    }]

    return(
        <>
            <Topbar/>

            <section className='data'>
                <div className='mainData'>
                    <img src="/photo/dataBackground.webp" className='backgroundMainData' alt="background" loading='eager' fetchPriority='high'/>
                    <div className='contentMainData'>
                        <h1 className='white'>Data Analytics</h1>
                    </div>

                    {/* <div className='contentMainBigMobile'>
                        <h1 className='white'>Data Analytics</h1>
                    </div> */}
                </div>
            </section>

            <section className="contentBig">
                <div className="width70">
                    <h1 style={{fontSize: '32px'}}>{t("dataanalytic1")}</h1>
                    <p className="textNormal">{t("dataanalytic2")}</p>
                
                    <p className="titleNormal">Data Analytics Solutions</p>
                    <p className="textNormal">{t("dataanalytic3")}</p>

                    {listitem.map((item, index) => (
                    <div key={index} className="itemBig" style={{marginBottom: '8px'}}>
                        <div style={{display: 'flex'}} alt="check">
                            <img src={checklist} alt="what?"/>
                        </div>
                        <p className="textNormal textAlignStart" style={{margin: '0px'}}>{item}</p>
                    </div>
                    ))}

                    <p className="titleNormal">{t("dataanalytic4")}</p>

                    {listwhy.map((item, index) => (
                    <div key={index} className="itemWhy">
                        <div style={{display: 'flex'}}>
                            <img src={checklistSize} alt="check"/>
                        </div>
                        <div>
                        <h2 className="titleItemWhyBig">{item.title}</h2>
                        <h2 className="textItemWhyBig">{item.text}</h2>
                        </div>
                    </div>
                    ))}
                </div>

                <div className="cardSoftware">
                    <p className="titleHigh">{t("sidecardtitle")}</p>
                    <p className="textNormal mb64">{t("sidecardtext")}</p>
                    <div>
                        <button className="buttonBlack" onClick={() => {window.open('https://wa.me/6281703090603', '_blank')}}>{t("hpc1colaboration")}</button>
                    </div>
                </div>
            </section>

            <Footer/>
        </>
    )
}

export default DataAnalytics